import React from "react"
import {viewportContext} from "./viewportContext"

export const useViewport = () => {
    const {width, height} = React.useContext(viewportContext)
    return {width, height}
}